import { Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { isValidEmail } from '../../../../utils';
import auth from '../../../../utils/auth';
import { useMergeState } from '../../../../utils/hooks';
import { toastrSuccess } from '../../../../utils/toastNotification';
import NormalButton from '../../buttons/normalButton';
import NormalInput from '../../inputs/normalInput';
import {
  changeEmail, getForm, getSchema, updateUser,
} from './helper';
import './style.scss';

const ChangeEmailModal = (props) => {
  const location = useLocation();
  const params = useParams();
  const [state, setState] = useMergeState({
    loading: false,
  });

  const schema = getSchema();
  const form = getForm(schema);

  const userId = useMemo(() => (location.pathname.includes('/my-profile') ? auth.getLoginData()?.id : params?.id));
  const isMyProfile = useMemo(() => (location.pathname.includes('/my-profile')));
  const onCancel = () => {
    props.onCancel();
  };

  const onConfirm = (newEmail) => {
    props.onConfirm(newEmail);
    onCancel();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    form.clearErrors('newEmail');
    // check isValid Email
    if (!isValidEmail(form.getValues('newEmail'))) {
      form.setError('newEmail', { message: 'Email format is incorrect.' }, { shouldFocus: true });
      return;
    }
    if (form.getValues('newEmail') === form.getValues('currentEmail')) {
      form.setError('newEmail', { message: 'The new email cannot be the same as the current one.' }, { shouldFocus: true });
      return;
    }
    setState({ loading: true });
    if (isMyProfile) {
      const changedEmail = await changeEmail(form.getValues('newEmail'));
      if (!changedEmail?.isSuccess) {
        form.setError('newEmail', { message: 'This email has existed.' }, { shouldFocus: true });
        setState({ loading: false });
        return;
      }
      onConfirm(form.getValues('newEmail'));
    } else {
      const updatedUser = await updateUser({ userId, newEmail: form.getValues('newEmail') });
      if (!updatedUser?.isSuccess) {
        form.setError('newEmail', { message: 'This email has existed.' }, { shouldFocus: true });
        setState({ loading: false });
        return;
      }
      onConfirm(updatedUser.user.email);
    }
    setState({ loading: false });
    toastrSuccess('Email changed successfully');
  };

  useEffect(() => {
    if (props.visible) {
      form.setValue('currentEmail', props.data[1]?.value);
    }
    form.resetField('newEmail');
  }, [props.visible]);

  return (
    <Modal
      className="change-email-modal"
      title="Change email"
      visible={props.visible}
      onCancel={onCancel}
      maskClosable={props.maskClosable}
      footer={[
        <NormalButton
          className="save-changes-btn"
          key="submit"
          text="Change email"
          type="primary"
          loading={state.loading}
          disabled={!form?.formState?.isValid}
          onClick={onSubmit}
        />,
      ]}
    >
      <form onSubmit={onSubmit}>
        <NormalInput
          name="currentEmail"
          title="Current email"
          isUseForm
          control={form?.control}
          placeholder="Current email"
          disabled
        />
        <NormalInput
          className="mt-10"
          name="newEmail"
          title="New email"
          isRequired
          isUseForm
          control={form?.control}
          placeholder="New email"
          errMsg={form?.formState?.errors?.newEmail?.message}
        />
      </form>
    </Modal>
  );
};

ChangeEmailModal.defaultProps = {
  visible: false,
  maskClosable: false,
  data: {},

  onCancel: () => {},
  onConfirm: () => {},
};

ChangeEmailModal.propTypes = {
  visible: PropTypes.bool,
  maskClosable: PropTypes.bool,
  data: PropTypes.shape(),

  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ChangeEmailModal;
